import insertSpaces from '@aytm/app/stats/lib/draft-js/autocompletePlugin/lib/insert-spaces'
import insertToken from '@aytm/app/stats/lib/draft-js/autocompletePlugin/lib/insert-token'

export default function processSuggestionData(
  type,
  { canBeCompleted, token, label, parserResult, completeAfterInsert, description = null }
) {
  const processedText = insertToken(type, { canBeCompleted, token, label, parserResult })
  if (!processedText) {
    return null
  }

  const previousToken =
    canBeCompleted && !parserResult.text.nonParsed ? parserResult.tokens.type.prelast : parserResult.tokens.type.last

  const { newTextBefore, newTextAfter, fuzzy, fuzzyIndexOf, offsetText } = processedText
  const { spaceBefore, spaceAfter } = insertSpaces({
    newTextBefore,
    newTextAfter,
    previousToken,
    parserResult,
    token,
    label
  })

  const suggestion = {
    id: label,
    token,
    label,
    textBefore: completeAfterInsert
      ? newTextBefore + spaceBefore + label
      : newTextBefore + spaceBefore + label + spaceAfter,
    textAfter: completeAfterInsert ? (newTextAfter ? spaceAfter + newTextAfter : '') : newTextAfter
  }

  if (fuzzy) {
    suggestion.fuzzy = fuzzy
  }

  if (offsetText) {
    suggestion.offsetText = offsetText
  }

  if (fuzzyIndexOf) {
    suggestion.fuzzyIndexOf = fuzzyIndexOf
  }

  if (null !== description) {
    suggestion.description = description
  }

  return suggestion
}
